import React from "react";

function WhyWeNeedAIImageDetector() {
  return (
    <div className="container" style={{ marginTop: "7rem" }}>
      {/* Title section */}
      <div>
        {/* Why do we need AI image detectors */}
        <h1 className="display-6">Why do we need AI image detectors?</h1>

        {/* Description section */}
        <div>
          <h5 className="mt-5">Preventing Misinformation and Deepfakes:</h5>
          <p className="lead">
            <label className="mt-2">
              <b>Problem:</b> AI generated images, including deepfakes, can be
              used to spread false or misleading information.
            </label>
            <br />
            <label className="mt-2">
              <b>Need:</b> An effective deepfake detection system can flag or
              block such content before it misleads the public.
            </label>
            <br />
            <label className="mt-2">
              {" "}
              <b>Example:</b> A fake image detector could prevent a viral photo
              of a someone doing something controversial, created entirely by
              AI.
            </label>
          </p>
        </div>

        <div>
          <h5 className="mt-5">Protecting Trust in Media and Journalism:</h5>
          <p className="lead">
            <label className="mt-2">
              <b>Problem:</b> With the rise of realistic synthetic media, it’s
              harder to trust what we see online.
            </label>
            <br />
            <label className="mt-2">
              <b>Need:</b> Newsrooms need AI image recognition tools to verify
              whether an image is authentic or AI generated.
            </label>
            <br />
            <label className="mt-2">
              {" "}
              <b>Example:</b> A journalist using an image authenticity checker
              to confirm whether a photo from a conflict zone is real.
            </label>
          </p>
        </div>

        <div>
          <h5 className="mt-5">Academic and Artistic Integrity:</h5>
          <p className="lead">
            <label className="mt-2">
              <b>Problem:</b> Students and artists might use AI generated
              content and falsely claim it as original work.
            </label>
            <br />
            <label className="mt-2">
              <b>Need:</b> Schools and publishers require tools for AI generated
              content verification.
            </label>
            <br />
            <label className="mt-2">
              {" "}
              <b>Example:</b> Art competitions using a fake image identification
              tool to ensure only original work is accepted.
            </label>
          </p>
        </div>

        <div>
          <h5 className="mt-5">Content Moderation on Social Platforms:</h5>
          <p className="lead">
            <label className="mt-2">
              <b>Problem:</b> Harmful or explicit content created by AI can be
              difficult to detect manually.
            </label>
            <br />
            <label className="mt-2">
              <b>Need:</b> Social media platforms benefit from synthetic media
              detection systems to identify and remove inappropriate content.
            </label>
            <br />
            <label className="mt-2">
              {" "}
              <b>Example:</b> Automatically flagging deepfake images or
              AI-generated violence on platforms like Instagram or X.
            </label>
          </p>
        </div>

        <div>
          <h5 className="mt-5">Security and Identity Protection:</h5>
          <p className="lead">
            <label className="mt-2">
              <b>Problem:</b> Scammers use AI generated images to create fake
              profiles or IDs.
            </label>
            <br />
            <label className="mt-2">
              <b>Need:</b> Banks and digital services need AI image detectors to
              verify user authenticity.
            </label>
            <br />
            <label className="mt-2">
              {" "}
              <b>Example:</b> Dating apps using fake image detection to prevent
              catfishing and impersonation.
            </label>
          </p>
        </div>

        <div>
          <h5 className="mt-5">Legal and Ethical Compliance:</h5>
          <p className="lead">
            <label className="mt-2">
              <b>Problem:</b> Regulations may require disclosure when AI is
              used, especially in political or advertising content.
            </label>
            <br />
            <label className="mt-2">
              <b>Need:</b> AI image detection tools help enforce transparency
              and compliance.
            </label>
            <br />
            <label className="mt-2">
              {" "}
              <b>Example:</b> A public campaign using AI generated content must
              be flagged by AI generated image verification tools to remain
              lawful.
            </label>
          </p>
        </div>
      </div>
    </div>
  );
}

export default WhyWeNeedAIImageDetector;
